import React, { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'

// components
import { CButton } from '@coreui/react-pro'
import AppCard from 'src/components/AppCard'
import AppTable from 'src/components/AppTable'
import AppCardHeader from 'src/components/card/AppCardHeader'
import AppDetails from '../../components/details/claim-history-details/AppDetails'

// helpers
import Axios from 'src/helpers/axios'
import { columnClaimHistoryGameList } from '../../components/table-column/TableColumnList'
import { formUrlQuery } from '../../helpers/format-queries'

// styling
import { styleButtonVars2 } from '../../components/custom-styles/buttonStyles'

const ClaimHistoryDetails = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const params = useParams()
  const { id } = params

  const [claimHistoryDetails, setClaimHistoryDetails] = useState('')
  const [gameVoucherList, setGameVoucherList] = useState([]);
  const [claimHistoryListCount, setGameVoucherListCount] = useState(0);
  const [gameVoucherListPerPage, setGameVoucherListPerPage] = useState(10);
  const [activeGameVoucherListPage, setActiveGameVoucherListPage] = useState(1);
  const [searchGameVoucherListFilter, setSearchGameVoucherListFilter] = useState("");
  const [columnGameVoucherListSorter, setColumnGameVoucherListSorter] = useState({ column: "createdAt", state: "desc" });

  useEffect(() => {
    let queries = {
      search: searchGameVoucherListFilter,
      limit: gameVoucherListPerPage,
      offset: gameVoucherListPerPage * activeGameVoucherListPage - gameVoucherListPerPage,
      sort:
        (columnGameVoucherListSorter &&
          `${columnGameVoucherListSorter.column}-${columnGameVoucherListSorter.state}`) ||
        "",
    };
    if (claimHistoryDetails) {
      queries.client_voucher_id = claimHistoryDetails?.client_voucher?.id
      queries = formUrlQuery(queries);
      fetchAllGameVoucher(queries);
    }
  }, [
    searchGameVoucherListFilter,
    gameVoucherListPerPage,
    activeGameVoucherListPage,
    columnGameVoucherListSorter,
    claimHistoryDetails
  ]);

  useEffect(() => {
    fetchClaimHistoryDetails()
  }, [id]);

  const fetchClaimHistoryDetails = () => {
    Axios({
      method: "get",
      url: `/api/gamepass/v1/history/detail/${id}`,
    })
      .then(({ data }) => {
        if (data?.success) {
          setClaimHistoryDetails(data?.value)
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }

  const handleSearchItems = (search) => {
    setActiveGameVoucherListPage(1)
    setSearchGameVoucherListFilter(search);
  }

  const fetchAllGameVoucher = (queries) => {
    dispatch({
      type: 'SET_IS_LOADING',
      isLoading: true
    })
    Axios({
      method: "get",
      url: `/api/gamepass/v1/history/detail/game-voucher/list?${queries}`
    })
      .then(({ data }) => {
        const tempClaimHistoryList = data?.value?.map((d) => ({
          ...d,
          voucher_code: d?.game_voucher?.voucher_code,
          game_name: d?.game_voucher?.game?.game_name
        }));

        setGameVoucherList(tempClaimHistoryList);
        if (activeGameVoucherListPage === 1) {
          setGameVoucherListCount(data?.count);
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        dispatch({
          type: 'SET_IS_LOADING',
          isLoading: false
        })
      })
  };

  return (
    <>
      <div className='d-grid gap-2 d-md-flex justify-content-md-start mb-3'>
        <CButton style={styleButtonVars2} onClick={() => navigate(-1)}>
          Back
        </CButton>
      </div>
      <AppCard
        className='mt-4 mb-4'
        headerTitle={
          <AppCardHeader
            headerTitle={<h4>Claim History Details</h4>}
          />
        }
        bodyContent={
          <AppDetails
            claimHistoryDetails={claimHistoryDetails}
          />
        }
        lowerBodyContent={
          <AppCard 
            className='mb-4'
            headerTitle={<h4>Game Voucher List</h4>}
            bodyContent={
              <AppTable
                gameVoucherListPage
                tableFilter
                tableColumns={columnClaimHistoryGameList}
                tableContent={gameVoucherList}
                contentPerPage={gameVoucherListPerPage}
                activeContentPage={activeGameVoucherListPage}
                contentCount={claimHistoryListCount}
                searchContentFilter={searchGameVoucherListFilter}
                setActiveContentPage={setActiveGameVoucherListPage}
                setSearchContentFilter={handleSearchItems}
                setContentPerPage={setGameVoucherListPerPage}
                setColumnContentSorter={setColumnGameVoucherListSorter}
                isShowDropdownMenu={false}
              />
            }
          />
        }
      />
    </>
  )
}

export default ClaimHistoryDetails
